import type { HelpFile } from '../../types/help'
import { RestConfigCardTestIds } from '../../../testids/RestConfigCardTestIds'

export const restConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [RestConfigCardTestIds.restConfigCard]: 'REST configuration for an outbound connector — how IAM calls the target system to grant and revoke access.',
    [RestConfigCardTestIds.cardTitleRestConfig]: null,
    [RestConfigCardTestIds.btnCreateRestConfig]: 'Create the REST configuration for this connector.',
    [RestConfigCardTestIds.btnEditRestConfig]: null,
    [RestConfigCardTestIds.selectRestAuthType]: 'Authentication scheme when calling the target system — basic auth, bearer token, or OAuth2.',
    [RestConfigCardTestIds.selectRestGrantMethod]: 'HTTP method used to grant access — POST or PUT.',
    [RestConfigCardTestIds.selectRestRevokeMethod]: 'HTTP method used to revoke access — DELETE or PUT.',
    [RestConfigCardTestIds.restAuthSecretRef]:
      'Reference to the secret used to authenticate outbound REST calls.',
    [RestConfigCardTestIds.restGrantHeadersDisplay]:
      'HTTP headers sent on every grant call to the target system.',
    [RestConfigCardTestIds.restRevokeHeadersDisplay]:
      'HTTP headers sent on every revoke call to the target system.',
  },
}
